export default function RequestEnvelope(requestGroup, auth, envelopeOptions) {
  this.setRequestGroup(requestGroup);

  this.auth = auth;
  this.subRequests = [];
  this.envelopeOptions = envelopeOptions || {};
}

RequestEnvelope.prototype.getRequestGroup = function() {
  return this.requestGroup;
};

RequestEnvelope.prototype.setRequestGroup = function(requestGroup) {
  this.requestGroup = requestGroup;
};

RequestEnvelope.prototype.getJson = function() {
  var i;
  var ret = {
    request : {
      ...this.auth.getData(),
    }
  };

  if (this.envelopeOptions.outputFormat) {
    ret.request.outputFormat = this.envelopeOptions.outputFormat;
  }

  if (this.envelopeOptions.errorURL) {
    ret.request.errorURL = this.envelopeOptions.errorURL;
  }

  if (this.subRequests.length) {
    ret.request.requestList = [];

    for (i in this.subRequests) {
      var cur = this.subRequests[i];

      var obj = {};
      obj[cur.name] = cur.params;

      if (cur.requestID)
        obj.id = cur.requestID;

      ret.request.requestList.push(obj);
    }
  }

  return ret;
};

RequestEnvelope.prototype.addSubRequest = function(name, params, requestID) {
  this.subRequests.push({
    name : name,
    params : params,
    requestID : requestID
  });
};

RequestEnvelope.prototype.getSubRequest = function(index) {
  index = index || 0;

  return this.subRequests[index];
};

RequestEnvelope.prototype.getSubRequests = function() {
  return this.subRequests;
};

RequestEnvelope.prototype.setOutputFormat = function(format) {
  this.envelopeOptions.outputFormat = format;
};

RequestEnvelope.prototype.getOutputFormat = function() {
  return this.envelopeOptions.outputFormat || 'json';
};

RequestEnvelope.prototype.getErrorURL = function() {
  return this.envelopeOptions.errorURL || null;
};
